<template>
<div class="cmui-number form" :class="size">
    <div class="inputGroup"
         :class="{'inputGroup-reverse':reverse,'inputGroup-radius':radius}"
         @click.stop="">
        <div class="input_addon"
             @click.stop="changeNumber(-1, 'minus')"
             :class="{'disabled':!canMin}"
             style="padding:0;border-radius: 4px 0 0 4px">－</div>
        <input class="flex1"
               type="number"
               v-model="number"
               :readonly="readonly">
        <div class="input_addon"
             @click.stop="changeNumber(1, 'plus')"
             :class="{'disabled':!canMax}"
             style="padding:0;border-radius: 0 4px 4px 0">＋</div>
    </div>
</div>
</template>
<script>
export default {
	methods:{
        changeNumber(num, type){
	        if( (num == 1 && !this.canAdd) || (num == -1 && !this.canSub) ){
		        return;
	        }

	        this.number = +this.number + num;

			if( this.max || this.max === 0 ){
		        this.number = this.number >= this.max ? this.max : this.number;
	        }

	        if( this.min || this.min === 0 ){
		        this.number = this.number <= this.min ? this.min : this.number;
	        }

	        this.$dispatch('numChange', this, this.number, type);

	        if( this.number === this.max ){
		        this.$dispatch('numMax', this, this.number, type);
	        }

	        if( this.number === this.min ){
		        this.$dispatch('numMin', this, this.number, type);
	        }

	        this.start = this.number;
        }
	}
	, props: {
		reverse: {
			type: Boolean
		}
		, radius: {
			type: Boolean
		}
		, max: {
			type: Number
		}
		, min: {
			type: Number
		}
		, canAdd: {
			type: Boolean
			, default: true
		}
		, canSub: {
			type: Boolean
			, default: true
		}
		, start: {
			type: Number
		}
		, readonly: {
			type: Boolean
			, default: false
		}
		, target: {
			type: Object
		}
		, size: {
			type: String
			, default: ''
		}
		, addFn: Function
		, subFn: Function
	}
	, data(){
		return {
			number: this.start || 0
		};
	}
	, computed: {
		canMax(){
			if( this.max || this.max === 0 ){
				return this.number < this.max && this.canAdd;
			}
			else{
				return this.canAdd;
			}
		}
		, canMin(){
			if( this.min || this.min === 0 ){
				return this.number > this.min && this.canSub;
			}
			else{
				return this.canSub;
			}
		}
	}
	, watch: {
		number(){
			this.changeNumber(0);
		}
	}
};
</script>
<style lang="scss">
.cmui-number.form .inputGroup input {
	border-radius: 0;
}
</style>